
import Vue from 'vue';
import Component from 'vue-class-component';
import BaseLookup from './BaseLookup';
import TLookupSkin from './LookupSkin.vue';

@Component({
  name: 'CompanyLookup',
  components: {
    TLookupSkin,
  },
})
export default class CompanyLookup extends BaseLookup {
  dialogVisible = false;

  suggestionControllerName() {
    return 'Company';
  }

  keyPrefix() {
    return 'Company';
  }

  openDialog() {
    this.dialogVisible = true;
  }

  handleSelect(val) {
    this.addItem({
      key: val.key,
      title: val.value,
    });
  }

  linkClick(companyId, row) {
    const item = {
      key: `${this.keyPrefix()}-${companyId}`,
      title: row.COMPANYNAME.value,
    };
    this.addItem(item);
    if (!this.multipleSelection) {
      this.dialogVisible = false;
    }
  }
}
